export const twoDigit = (num: number): string => `0${num}`.slice(-2);
